import { render, staticRenderFns } from "./ResourcesNcf.vue?vue&type=template&id=6ac9c6e7&"
import script from "./ResourcesNcf.vue?vue&type=script&lang=js&"
export * from "./ResourcesNcf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports